<template>
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.6201 7.161C11.6201 5.74181 10.7999 4.51556 9.60986 3.92456V10.4014C10.7999 9.80644 11.6201 8.58019 11.6201 7.161Z" />
        <path d="M0.52832 4.81485V9.63934H3.74463L7.76505 13.6598V0.794434L3.74463 4.81485H0.52832Z" />
        <path d="M9.37158 0.175049V1.83546C11.6954 2.52699 13.392 4.67788 13.392 7.22683C13.392 9.77577 11.6954 11.9267 9.37158 12.6182V14.2786C12.5919 13.5469 15.0001 10.6723 15.0001 7.22683C15.0001 3.78135 12.5919 0.90675 9.37158 0.175049Z" />
    </svg>
</template>